export interface ContactLocation {
  title: string
  address: string
}

export function parseContactLocations(
  raw?: string | null,
  legacy?: { mures?: string, turda?: string },
): ContactLocation[] {
  if (raw) {
    try {
      const parsed = JSON.parse(raw) as ContactLocation[]
      if (Array.isArray(parsed)) {
        return parsed.filter((item) => item.title?.trim() && item.address?.trim())
      }
    } catch {
      // fall through to legacy fields
    }
  }

  const result: ContactLocation[] = []
  if (legacy?.mures?.trim()) {
    result.push({ title: 'Sediu Mureș', address: legacy.mures.trim() })
  }
  if (legacy?.turda?.trim()) {
    result.push({ title: 'Sediu Turda', address: legacy.turda.trim() })
  }
  return result
}
